module.exports = __webpack_public_path__ + "static/media/link-download-icon.53872890.svg";